import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { ComponentFakeLink } from 'common/link/link-component-fake.js';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ICON_MODIFIERS, IInlineWarningProps } from './header-warning-types.js';
import { trackNavigateEvent } from 'utilities/posthog-tracking';

const PanelHeaderLink = ({
  label,
  onClickCB,
}: {
  onClickCB?: (e: React.MouseEvent<Element, MouseEvent>) => void;
  label: string | undefined;
}) => {
  return (
    <ComponentFakeLink classes="fake-link--opacity" onClickCB={onClickCB}>
      <span className="fake-link fake-link--opacity u-textSemibold">{label}</span>
    </ComponentFakeLink>
  );
};

export const PanelLargeHeaderWarnings = ({ warnLevel, label, icon, url }: IInlineWarningProps) => {
  const iconModifier = icon || ICON_MODIFIERS[warnLevel] || '';
  const navigate = useNavigate();
  const onClickCB = url
    ? (e: React.MouseEvent<Element, MouseEvent>) => {
        /** Prevent outer div link working */
        navigate(url);
        e.stopPropagation();
        e.preventDefault();
        trackNavigateEvent("severe_weather_banner", label + "_link");
      }
    : undefined;
  return (
    <li
      className={classNames('WeatherWarning-bar-warning-item u-sm-hidden u-md-hidden u-lg-block u-xl-block', warnLevel)}
    >
      <IconWithText
        classes={classNames('IconWithText--small IconWithText--vCenter', {
          'IconWithText--noIcon': warnLevel === 'blue',
        })}
        icon={iconModifier as IconNameV1}
      >
        <PanelHeaderLink label={label} onClickCB={onClickCB} />
      </IconWithText>
    </li>
  );
};
